import React, {useState} from "react";
import {Button, Modal, Table } from "antd";
import {Title} from "./Common";
import 'antd/dist/antd.css'
import 'ant-design-draggable-modal/dist/index.css'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestion} from "@fortawesome/free-solid-svg-icons";

const WidgetHelpChart = () => {
  const [visible, setVisible] = useState(false);
  const dataSource = [
    {
      key: '1',
      kind: '시가화면적',
      detail: '▷ 시가화면적은 개발된 지역을 의미\n' +
        '▷ 시가화면적 비율(%) =\n' +
        '(주거+상업+공업+녹지지역 면적 / 전체면적) x 100',
      grade: '10등급',
      etc: '출처 : 국가공간정보포털\n' +
        'nsdi.go.kr',
      group: '지역지수',
    },
    {
      key: '2',
      kind: '재정자주도',
      detail: '▷ 실질적인 자치단체의 재원 활용능력\n' +
        '▷ (자체수입+자주재원)의 합 / 예산규모의 합 x 100',
      grade: '10등급',
      etc: '출처 : 지방재정365\n' +
        'lofin.mois.go.kr',
      group: '지역지수',
    },
    {
      key: '3',
      kind: '인구비율',
      detail: '▷ (해당지역 인구 / 전체인구) x 100',
      grade: '10등급',
      etc: '출처 : 국가통계포털\n' +
        'kosis.kr',
      group: '지역지수',
    },
    {
      key: '4',
      kind: '무선국비율',
      detail: '▷ (해당지역 무선국 수 / 전체무선국 수) x 100',
      grade: '10등급',
      etc: '출처 : KCA 자체보유',
      group: '전파지수',
    },
    {
      key: '5',
      kind: '전파Tech 지수',
      detail: '▷ (4G 무선국 수 / 2G + 3G 무선국 수) x 100',
      grade: '10등급',
      etc: '출처 : KCA 자체보유',
      group: '전파지수',
    },
    {
      key: '6',
      kind: '정보통신\n' +
        '자격현황',
      detail: '▷ (해당지역내 자격증 보유자 수 / 전체 자격증 보유자 수) x 100',
      grade: '10등급',
      etc: '출처 : KCA 자체보유',
      group: '전파지수',
    },
  ];

  return (
    <>
      <Button style={STYLE_CLOSE} shape="circle" onClick={() => setVisible(visible => !visible)}>
        <FontAwesomeIcon icon={faQuestion} color={"#F373BA"}/>
      </Button>

      <Modal
        style={{zIndex:11}}
        centered
        width={900}
        closable={false}
        bodyStyle={{padding: 30, height:480}}
        visible={visible}
        getContainer={false}
        mask={false}
        footer={null}
        title={
          <Title children={'전파 도시화 지수란?'}
                 extra={
                   <Button onClick={() => setVisible(visible => !visible)}>
                     닫기
                   </Button>
                 }/>
        }
      >
        <div>
          <hr/>
          <Table dataSource={dataSource}
                 size={"small"}
                 bordered={true}
                 pagination={false}
                 columns={
                   [
                     {
                       title: '분류',
                       dataIndex: 'group',
                       key: 'group',
                       width: 50,
                       render: (value, row, index) => {
                         const obj = {
                           children: value,
                           props: {},
                         };
                         if (index === 0 || index === 3) {
                           obj.props.rowSpan = 3;
                         } else {
                           obj.props.rowSpan = 0;
                         }
                         return obj;

                       }
                     },
                     {
                       title: '지수명',
                       dataIndex: 'kind',
                       key: 'kind',
                       width: 100,
                       render: (value) => {
                         const obj = {
                           children: value,
                         };

                         obj.children = value.split('\n').map(line => {
                           return (<div key={line} style={{textAlign: 'center'}}>{line}<br/></div>)
                         });
                         return obj;
                       }
                     },
                     {
                       title: '지수설명',
                       dataIndex: 'detail',
                       key: 'detail',
                       width: 400,
                       render: (value) => {
                         const obj = {
                           children: value,
                         };

                         obj.children = value.split('\n').map(line => {
                           return (<span key={line}>{line}<br/></span>)
                         });
                         return obj;
                       }
                     },
                     {
                       title: '등급',
                       dataIndex: 'grade',
                       key: 'grade',
                       width: 60,
                     },
                     {
                       title: '비고',
                       dataIndex: 'etc',
                       key: 'etc',
                       width: 160,
                       render: (value) => {
                         const obj = {
                           children: value,
                         };
                         obj.children = value.split('\n').map(line => {
                           return (<span key={line}>{line}<br/></span>)
                         });
                         return obj;
                       }
                     },
                   ]
                 }
          >
          </Table>
          <hr/>
        </div>
      </Modal>

    </>
  );
};

const STYLE_CLOSE = {
  position: 'absolute',
  opacity : 'inherit',
  top: 46.5,
  right: 40,
  padding: '4px',
  zIndex: 10,
};

export default WidgetHelpChart;
